import Component from './Content.vue';

export default {
  install(Vue) {
    Vue.component('BkfCardContent', Component);
  },
};
